module.exports = __webpack_public_path__ + "img/device_list.7be0f4d5.svg";